import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { initialTabs as tabs } from "./ingredients";
import { CommunityContentCss } from "../../styles/communityContent";
import MyQuestions from "./myQuestions";
import CommunityQuestion from "./communityQuestion";
import AskQuestion from "./askQuestion";

const CommunityContent = () => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  return (
    <>
      <CommunityContentCss />
      <div className="window">
        <nav>
          <ul>
            {tabs.map((item) => (
              <li
                key={item.label}
                className={item === selectedTab ? "selected" : ""}
                onClick={() => setSelectedTab(item)}
              >
                {`${item.icon} ${item.label}`}
                {item === selectedTab ? (
                  <motion.div className="underline" layoutId="underline" />
                ) : null}
              </li>
            ))}
          </ul>
        </nav>
        <main>
          <AnimatePresence>
            <motion.div
              key={selectedTab ? selectedTab.label : "empty"}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="display-content"
            >
              {selectedTab.code == "my" ? (
                <MyQuestions />
              ) : selectedTab.code == "com" ? (
                <CommunityQuestion />
              ) : (
                <AskQuestion />
              )}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </>
  );
};

export default CommunityContent;
